import React from "react";
import styled from "styled-components";

export default styled.a`
    height: 52px;
    width: 105px;
    text-align: center;
    display: inline-block;
    padding: 14px;
    cursor: pointer;
`;